import React, { useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./welcome.css";
import introVideo from "../video/intro2.mp4";
import logo from "../assets/logo_icon.png";

function Welcome() {
  const navigate = useNavigate();
  const videoRef = useRef(null);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.play().catch((err) => {
        console.warn("Autoplay blocked:", err);
      });
    }
  }, []);

  const handleVideoEnded = () => {
    navigate("/register");
  };

  return (
    <div className="welcome-container react-background">
      {/* HEADER */}
      <div className="welcome-card">
        <div className="welcome-header">
          <div className="logo-wrapper">
            <img src={logo} alt="HREXORA Logo" className="welcome-logo" />
          </div>

          <h1 className="welcome-title">
            Welcome to HREXORA Campus Connection
          </h1>
        </div>
      </div>

      {/* VIDEO */}
      <div className="video-wrapper">
        <div className="video-box">
          <video
            ref={videoRef}
            className="main-video"
            src={introVideo}
            autoPlay              // ✅ autoplay
            playsInline
            controls={false}      // ❌ no controls
            onEnded={handleVideoEnded}
            disablePictureInPicture
            controlsList="nodownload noplaybackrate nofullscreen noremoteplayback"
          />
        </div>
      </div>
    </div>
  );
}

export default Welcome;
